export default "__VITE_ASSET__DRhM42Ms__"